module.exports = ["just now",["%s second ago","%s seconds ago"],["%s minute ago","%s minutes ago"],["%s hour ago","%s hours ago"],["%s day ago","%s days ago"],["%s week ago","%s weeks ago"],["%s month ago","%s months ago"],["%s year ago","%s years ago"]]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/en-US.json
// module id = QDRa
// module chunks = 1 2